import { Grid, Stack } from "@mui/material";

import { ReactComponent as NotAuthorise } from "../../Assets/Images/Icon/NotAuthorisedICON.svg";
import { ReactComponent as NotFound } from "../../Assets/Images/Icon/NotFoundICON.svg";
import { Text1 } from "../../Components/atoms/Typography/Text/Text";
import { Theme } from "../../Style/Theme";

export const ErrorPage = ({ isAuthorise }) => {
  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      marginTop={"156px"}
      direction={"column"}
      spacing={1.5}
    >
      <Grid item>
        <Stack
          style={{
            backgroundColor: Theme.palette.background.primaryRed,
            padding: "20px",
            width: "136px",
            height: "136px",
            borderRadius: "50%",
          }}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {isAuthorise ? (
            <NotAuthorise role="img" type="img" aria-label="notAuthorise" />
          ) : (
            <NotFound role="img" type="img" aria-label="notFound" />
          )}
        </Stack>
      </Grid>
      <Grid item>
        <Text1
          text={
            isAuthorise
              ? "Sorry! You are not authorized to access this page"
              : "Page not found."
          }
          color={Theme.palette.background.primaryRed}
        />
      </Grid>
    </Grid>
  );
};
